export default __webpack_public_path__ + "static/media/banner.9b7f38fc.png";